export const GREEN = '#46C779'
export const BLUE = '#409FFF'
export const YELLOW = '#FFA500'
export const RED = '#FF0000'
export const TEXT = '';
export const ORANGE_GAME = '#FF9500';
export const TRANSPARENT = 'rgba(0,0,0,0)';
export const DASHLINE = '#ABABAB';
export const DEFAULT_FONT = 'SF Pro Display, sans-serif';
export const GRAY_2 = "#E6E6E6";
export const PURPLE = "#713FF4";
export const PINK = "#FFA1AA";
